module.exports = __webpack_public_path__ + "img/logo.8726862.png";